// eslint-disable  @typescript-eslint/no-explicit-any
import { AxiosError } from 'axios';
import { FunctionComponent, ReactElement, useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { apiClient } from '../../adapters/api-client';
import { DomTomInfos } from '../../adapters/api-client/referential/Referential.model';
import {
  AddressBisRules,
  AddressRules,
  ApiInput,
  ApiInputDS,
  ApiStatus,
  BaseInput,
  BaseInputDS,
  ComboInput,
  ComboInputDS,
  ZipCodeRules,
} from '../../components/DesignSystem';
import { store } from '../../store/store';
import { updateStore } from '../../store/store.actions';
import { CityItem } from '../../store/store.model';
import { ValidityHtmlElement } from '../../utils/DsType';
import DomtomErrorMessage from './components/DomTomErrorMessage';

const ContainerZipCodeInput = styled.div`
  width: 100%;
  base-input,
  api-input {
    --width-component: 110px;
  }
  combo-input:disabled {
    display: 'none';
  }
`;
/* eslint-disable @typescript-eslint/no-explicit-any */
const ContainerCity = styled.div`
  width: 100%;
  .cities-list {
    display: ${(props: any) => (props.displayCity ? 'flex' : 'none')};
  }
`;

const Adresse: FunctionComponent<Record<string, never>> = (): ReactElement => {
  const {
    state: { holder },
    geoLoc,
    dispatch,
  } = useContext(store);
  const checkInputCompleted = (size: number, input: string): boolean => {
    if (input && input.length !== 0) return input.length >= size;
    else return true;
  };
  //local store to check if zip code is a correct
  const [displayCity, setDisplayCity] = useState<boolean>(
    !!holder?.contact && !!holder?.contact.zipCode && checkInputCompleted(5, holder?.contact.zipCode.toString()),
  );
  const [isDomTom, setDomTom] = useState(false);
  const [domTomInfo, setDomTomInfo] = useState({} as DomTomInfos);
  const [cityItems, setCityItems] = useState<CityItem[]>([]);
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.KO);
  const zipCodeRef = useRef<ApiInputDS>(null);
  const addressBisRef = useRef<BaseInputDS>(null);
  const addressCityRef = useRef<ComboInputDS>(null);
  // on address change
  const onAddressChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { contact: { streetAddress: e.currentTarget?.value } } }));
  };
  // on addressBis change
  const onAddressBisChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    dispatch(updateStore({ holder: { contact: { additionalAddress: e.currentTarget?.value } } }));
  };
  const onZipCodeChange = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (holder?.contact?.zipCode != e.currentTarget?.value) {
      const cityInputValue: CityItem = {
        department: '',
        inseeNumber: '',
        name: '',
        zipCode: '',
      };
      dispatch(updateStore({ holder: { contact: { cityAddress: cityInputValue } } }));
      dispatch(updateStore({ holder: { contact: { zipCode: Number(e.currentTarget?.value) } } }));
      setDisplayCity(false);
      setDomTom(false);

      if (e.currentTarget?.value) loadCities(e.currentTarget?.value as string, geoLoc);
    }
  };

  useEffect(() => {
    if (displayCity && holder?.contact?.zipCode) {
      loadCities(holder?.contact.zipCode.toString(), geoLoc);
    }
  }, [displayCity]);

  useEffect(() => {
    if (!!zipCodeRef && zipCodeRef.current !== null) {
      (zipCodeRef.current as unknown as ApiInputDS).customValidityPattern = [
        {
          regexp: () => checkInputCompleted(5, (zipCodeRef.current as unknown as ApiInputDS)?.value as string),
          errorMessage: 'Veuillez remplir ce champ.',
        },
      ];
    }
  }, []);

  useEffect(() => {
    if (!!addressBisRef && addressBisRef.current !== null) {
      (addressBisRef.current as unknown as BaseInputDS).customValidityPattern = [
        {
          regexp: () => checkInputCompleted(2, (addressBisRef.current as unknown as BaseInputDS)?.value as string),
          errorMessage: 'Veuillez vérifier votre adresse, elle ne semble pas complète.',
        },
      ];
    }
  }, []);

  const loadCities = async (zipCode: string, geoLoc: string) => {
    try {
      if (zipCode && checkInputCompleted(5, zipCode)) {
        (zipCodeRef.current as unknown as ValidityHtmlElement).defaultErrorMessage = ' ';
        setApiStatus(ApiStatus.LOADING);
        const cities = await apiClient().referential.getCitiesByZipCode(zipCode, geoLoc);
        if (cities && cities.length !== 0) {
          setApiStatus(ApiStatus.OK);
          setCityItems(cities);
          setDisplayCity(true);
          (addressCityRef.current as unknown as ValidityHtmlElement).invalid = false;
          if (cities.length === 1) {
            dispatch(updateStore({ holder: { contact: { cityAddress: cities[0] } } }));
          }
        }
      }
    } catch (err) {
      setDisplayCity(false);
      if (zipCode && checkInputCompleted(5, zipCode)) {
        const error = err as AxiosError;
        if (error.response && error.response.status === 422) {
          //display domtom bloc
          const data: DomTomInfos = error.response.data
            ? ((error.response.data as any[])[0]?.additionalInformation as DomTomInfos)
            : ({} as DomTomInfos);
          setDomTomInfo(data);
          setDomTom(true);
        } else {
          (zipCodeRef.current as unknown as ValidityHtmlElement).defaultErrorMessage =
            'Votre code postal semble incorrect. Veuillez réessayer.';
        }
        setApiStatus(ApiStatus.KO);
        dispatch(
          updateStore({
            holder: {
              contact: {
                cityAddress: {
                  department: '',
                  inseeNumber: '',
                  name: '',
                  zipCode: '',
                },
              },
            },
          }),
        );
      }
    }
  };
  //select city
  const cityOnListSelect = (event: Event) => {
    const selectedCity = (event as CustomEvent).detail.value as CityItem;
    dispatch(updateStore({ holder: { contact: { cityAddress: selectedCity } } }));
  };
  // on blur city
  const onCityBlur = (e: Event & { currentTarget?: { value?: unknown } | null }) => {
    if (addressCityRef.current && addressCityRef.current !== null) {
      if (e.currentTarget?.value === '') {
        const cityInputValue: CityItem = {
          department: '',
          inseeNumber: '',
          name: '',
          zipCode: '',
        };
        dispatch(updateStore({ contact: { cityAddress: cityInputValue } }));
      }
    }
  };
  useEffect(() => {
    if (!!addressCityRef && addressCityRef.current !== null) {
      (addressCityRef.current as unknown as ComboInputDS).customValidityPattern = [
        {
          regexp: () => (addressCityRef.current as unknown as ValidityHtmlElement).checkComboValidity(),
          errorMessage: "L'information saisie est incorrecte.",
        },
        { regexp: "([A-Za-z0-9 '])", errorMessage: "L'information saisie est incorrecte." },
        { regexp: '.+', errorMessage: 'Veuillez renseigner votre ville.' },
      ];
    }
  }, [displayCity]);

  return (
    <>
      <BaseInput
        class="to-validate trackable-blur"
        required
        label="Adresse"
        data-id="address-input"
        maxLength="32"
        onInputChange={onAddressChange}
        onLetterChanged={onAddressChange}
        value={holder?.contact?.streetAddress || ''}
        replacement={AddressRules.replacement}
        customValidityPattern={AddressRules.customValidityPattern}
        placeholder="4, allée des maraîchers"
        error-message="Veuillez renseigner votre adresse."
      ></BaseInput>
      <BaseInput
        ref={addressBisRef}
        class="to-validate trackable-blur"
        show-required
        label="Complément d'adresse"
        data-id="address-bis-input"
        maxLength="32"
        onInputChange={onAddressBisChange}
        onLetterChanged={onAddressBisChange}
        value={holder?.contact?.additionalAddress || ''}
        replacement={AddressBisRules.replacement}
        placeholder="Digicode, bâtiment, étage..."
      ></BaseInput>
      <ContainerZipCodeInput>
        <ApiInput
          ref={zipCodeRef}
          class="to-validate trackable-blur"
          required
          label="Code Postal"
          data-id="zip-code-input"
          maxLength="5"
          mobile-type="number"
          onInputChange={onZipCodeChange}
          onLetterChanged={onZipCodeChange}
          value={holder?.contact?.zipCode || ''}
          replacement={ZipCodeRules.replacement}
          customValidityPattern={ZipCodeRules.customValidityPattern}
          placeholder="75001"
          default-error-message=""
          error-message=""
          api-status={apiStatus}
        ></ApiInput>
      </ContainerZipCodeInput>
      {isDomTom ? <DomtomErrorMessage domtomInfo={domTomInfo}></DomtomErrorMessage> : null}
      <ContainerCity {...{ displayCity }}>
        <ComboInput
          ref={addressCityRef}
          list-on-open
          shadow
          align-items="left"
          items={JSON.stringify(cityItems)}
          class="to-validate trackable-blur cities-list"
          field="name"
          label="Ville"
          placeholder="Sélectionnez une ville"
          maxLength="32"
          onListBlur={onCityBlur}
          onSelectedList={cityOnListSelect}
          value={holder?.contact?.cityAddress?.name || ''}
          selected={cityItems.length == 1 || undefined}
        ></ComboInput>
      </ContainerCity>
    </>
  );
};
export default Adresse;
